import StatusCode from "../enums/httpStatusCodes";

export const isForbidden = (status: number) => status === StatusCode.Forbidden;
